import { ReactNode, useRef } from 'react';
import { SnackbarProvider, useSnackbar, withSnackbar } from 'notistack';

export enum VariantTypes {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error'
}

type Props = {
  children: ReactNode;
};

export default function NotistackProvider({ children }: Props) {
  const notistackRef = useRef<any>(null);

  return (
    <>
      <SnackbarProvider
        ref={notistackRef}
        dense
        maxSnack={5}
        autoHideDuration={3000}
        variant={VariantTypes.Info}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {children}
      </SnackbarProvider>
    </>
  );
}

export { useSnackbar, withSnackbar };
